import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Container to be used by this library for inversion control. If container was not implicitly set then by default
 * container simply creates a new instance of the given class.
 *
 * @deprecated
 */
var defaultContainer = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
    this.instances = [];
  }
  _createClass(_class, [{
    key: "get",
    value: function get(someClass) {
      var instance = this.instances.find(function (i) {
        return i.type === someClass;
      });
      if (!instance) {
        instance = {
          type: someClass,
          object: new someClass()
        };
        this.instances.push(instance);
      }
      return instance.object;
    }
  }]);
  return _class;
}())();
var userContainer;
var userContainerOptions;
/**
 * Sets container to be used by this library.
 *
 * @deprecated
 */
export function useContainer(iocContainer, options) {
  userContainer = iocContainer;
  userContainerOptions = options;
}
/**
 * Gets the IOC container used by this library.
 *
 * @deprecated
 */
export function getFromContainer(someClass) {
  if (userContainer) {
    try {
      var instance = userContainer.get(someClass);
      if (instance) return instance;
      if (!userContainerOptions || !userContainerOptions.fallback) return instance;
    } catch (error) {
      if (!userContainerOptions || !userContainerOptions.fallbackOnErrors) throw error;
    }
  }
  return defaultContainer.get(someClass);
}